import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { OnboardingState, PhoneNumber } from './types';
import { formatNumber } from '@/utils/numbers';

const getters: GetterTree<OnboardingState, RootState> = {
  getSelectedNumber: (onboarding: OnboardingState): string => onboarding.selectedNumber,
  getSelectedNumberFormatted: (onboarding: OnboardingState): string => {
    return formatNumber(onboarding.selectedNumber);
  },
  getSelectedName: (onboarding: OnboardingState): string => onboarding.phoneNumber.name || '',
  getSelectedId: (onboarding: OnboardingState): string => onboarding.phoneNumber.id || '',
  getSelectedCallFlow: (onboarding: OnboardingState): object => onboarding.phoneNumber.callFlow || {},
  getSelectedTextFlow: (onboarding: OnboardingState): object => onboarding.phoneNumber.textFlow || {}
};

export default getters;
